import type { Editor } from '@tiptap/core'
import { shallowRef } from 'vue'

const activeNovelEditor = shallowRef<Editor | null>(null)

/**
 * Registers the novel TipTap editor currently mounted for chapter editing.
 * Used so saves can read getJSON() from the live editor.
 */
export function registerActiveNovelEditor(editor: Editor | null): void {
  activeNovelEditor.value = editor
}

export function clearActiveNovelEditor(editor?: Editor | null): void {
  if (!editor || activeNovelEditor.value === editor) {
    activeNovelEditor.value = null
  }
}

export function getActiveNovelEditorJson(): object | null {
  const editor = activeNovelEditor.value
  if (!editor || editor.isDestroyed) return null
  return editor.getJSON()
}

export function useActiveNovelEditor() {
  return { editor: activeNovelEditor }
}
